import { createContext } from "react";

const ContextGeneral = createContext();

export default ContextGeneral;
